import React, { useState, useEffect, useRef, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { createUseStyles } from 'react-jss'
import { useToasts } from 'react-toast-notifications'
import { useBoolean } from '@rothzerg/useboolean'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { get, set, has, map, find, includes, replace, split, isEmpty } from 'lodash'

import * as quotationActions from '../../actions/quotation'
import * as ratesActions from '../../actions/rates'
import * as modelsActions from '../../actions/models'
import * as widgetRules from '../rules/widget'
import Context from '../Context'
import BookingTitleBar from '../ui/Homepage/BookingWidget/BookingTitleBar'
import BookingSplitTitleBar from '../ui/Homepage/BookingWidget/BookingSplitTitleBar'
import BookingWidget from '../ui/Homepage/BookingWidget/BookingWidget'
import BookingColumn from '../ui/Homepage/BookingWidget/BookingColumn'
import BookingWidgetTitle from '../ui/Homepage/BookingWidget/BookingWidgetTitle'
import BookingSeachButton from '../ui/Homepage/BookingWidget/BookingSearchButton'
import DateTimeSelect from '../ui/Homepage/BookingWidget/DateTimeSelect'
import AgeSelect from '../ui/Homepage/BookingWidget/AgeSelect'
import LocationSelect from '../ui/Homepage/BookingWidget/LocationSelect'
import BookingPickupAccordion from '../ui/Homepage/BookingWidget/BookingPickupAccordion'
import FormInput from '../ui/Form/FormInput'
import Boxes from './Boxes'
import CookieTimeOutPopup from '../new/CookieTimeOutPopup'
import Gtm from '../../utils/gtm'
import { getCookie, setCookie } from '../../utils/cookies'
import { loggingEnabled } from '../../utils/logging'
import { match } from '../../utils/path'

const useStyles = createUseStyles(theme => ({
  PromoCodeLauncher: {
    color: 'rgb(51, 51, 51)',
    fontSize: '13px',
    textDecoration: 'none',
    padding: '8px 8px 8px 10px',
    display: 'inline-block',
    '&[validation-status="valid"]': { color: 'green' },
    '&[validation-status="invalid"]': { color: 'red' },
  },
}))

const Itinerary = () => {
  const classes = useStyles()
  const gtm = new Gtm(loggingEnabled)
  const context = useContext(Context)
  const [widgetCtxOpen, setWidgetCtxOpen] = useState(false)
  const { addToast } = useToasts()
  const dispatch = useDispatch()

  const workerGetRates = useSelector(state => state.app.worker.getRates)
  const quotation = useSelector(state => state.quotation)

  const { locations, locales, ages, switchboards, relocation, partners } = useSelector(
    state => state.models,
  )

  const currentTrip = useSelector(state => state.quotation.trips[quotation.trip])
  const [pickupLocation, setPickupLocation] = useState({
    label: 'Enter location',
    value: '',
    country: '',
    hours: null,
    drop_off_hours: null,
  })
  const [dropoffLocation, setDropoffLocation] = useState({
    label: 'Enter drop-off location',
    value: 'same-0',
    country: '',
    hours: null,
    drop_off_hours: null,
  })

  const [bookingDateTime, setBookingDateTime] = useState({
    pickup: null,
    dropoff: null,
  })
  const [pickupMinDate, setPickupMinDate] = useState(dateToNearestHalfHour())
  const [dropoffMinDate, setDropoffMinDate] = useState(null)

  const handleDateTimeChange = (type, date) => {
    let state = bookingDateTime
    state[type] = date
    if (type === 'pickup' && date) {
      const newDropoffMinDate = new Date(date)
      newDropoffMinDate.setDate(newDropoffMinDate.getDate() + 1)
      setDropoffMinDate(newDropoffMinDate)
    }
    setBookingDateTime(state)
  }

  const promocode = useSelector(state => state.models.promocode)
  const [promo, setPromo] = useState(currentTrip.promo)
  const [searchPromocode, setSearchPromocode] = useState(currentTrip?.promo ?? promocode ?? '')

  const [searchDiscountcode, setSearchDiscountcode] = useState(currentTrip.discount)
  const [searchITCode, setSearchITCode] = useState(currentTrip?.ITCode ?? '')
  const [searchType, setSearchType] = useState(currentTrip.searchType)

  const [velocitynumber, setvelocitynumber] = useState(currentTrip.velocitynumber)
  const [velocityDropdown, setVelocityDropdown] = useBoolean()
  const [blueChipMemberDropdown, setBlueChipMemberDropdown] = useBoolean()
  const [autoClubDropdown, setAutoClubDropdown] = useBoolean()

  const [blueChipMembershipActive, setblueChipMembershipActive] = useBoolean()
  const [autoClubActive, setautoClubActive] = useBoolean()

  const [bluechipnumber, setbluechipnumber] = useState(currentTrip.bluechipnumber)
  const [bluechipname, setbluechipname] = useState(currentTrip.bluechipname)
  const [autoclubmembershiptype, setautoclubmembershiptype] = useState(
    currentTrip.autoclubmembershiptype,
  )
  const [autoclubmembership, setautoclubmembership] = useState(currentTrip.autoclubmembership)
  const [promoDropdown, setPromoDropdown] = useBoolean()

  const [widgetSkin, setWidgetSkin] = useState({})
  const [allLocations, setAllLocations] = useState([])

  const [itineraryLbls, setItineraryLbls] = useState({})
  const [pagesLbls, setPagesLbls] = useState({})
  const [driverAge, setDriverAge] = useState(quotation.trips[quotation.trip].dob ?? null)
  const [driveAgeOptions, setDriveAgeOptions] = useState([])

  const [nzCrossIslandBookingAllowed, setNzCrossIslandBookingAllowed] = useState(false)
  const [splitbookingToSouthNotAllowed, setSplitbookingToSouthNotAllowed] = useState(false)
  const [splitbookingToNorthNotAllowed, setSplitbookingToNorthNotAllowed] = useState(false)
  const [nzCrossIslandBooking, setNzCrossIslandBooking] = useState(false)
  const [ferrybooking, setFerrybooking] = useState(false)
  const [relocationChecked, setRelocationChecked] = useState(false)
  const [iframe, setIframe] = useState(false)
  const [afterHourPickup, setAfterHourPickup] = useState(false)
  const [availabilityCheck, setAvailabilityCheck] = useState(false)

  const [pageLoaded, setPageLoaded] = useState(false)
  const [clickedSearchSplit, setClickedSearchSplit] = useState(false)
  const [clickedSearchFinal, setClickedSearchFinal] = useState(false)

  const [promoCampaign, setPromoCampaign] = useState(currentTrip.promoCampaign)
  const [velocityabn, setVelocityAbn] = useState(currentTrip.velocityabn)
  const [widgetForceOpen, setWidgetForceOpen] = useState(false)

  const promoWrapperRef = useRef(null)
  const autoclubWrapperRef = useRef(null)
  const bluechipWrapperRef = useRef(null)
  const velocityWrapperRef = useRef(null)

  const useOutsidePromo = (ref, fn) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          fn.false()
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref, fn])
  }
  useOutsidePromo(promoWrapperRef, setPromoDropdown)
  useOutsidePromo(autoclubWrapperRef, setAutoClubDropdown)
  useOutsidePromo(bluechipWrapperRef, setBlueChipMemberDropdown)
  useOutsidePromo(velocityWrapperRef, setVelocityDropdown)

  const [partner, setPartner] = useState({})
  const defaultCountry = context.env['country']

  const [refreshTrip, setRefreshTrip] = useState(quotation.trip) // Used to manage render refresh of Components
  const [forceRefresh, setForceRefresh] = useState(false) // Used to manage render refresh of Components

  const [searchButtonClicked, setSearchButtonClicked] = useState(false)
  const [searchMode, setSearchMode] = useState(match('/bookings/', location.pathname))
  const [searchParams, setSearchParams] = useState(new URLSearchParams(''))

  const arr_path = location.pathname.toLowerCase().split('/')
  let mode =
    quotation.mode != 'default'
      ? quotation.mode
      : get(arr_path, '1', '') == 'experience'
      ? get(arr_path, '2', 'default')
      : 'default'

  useEffect(() => {
    setupLocationsConsolidated()
  })

  useEffect(() => {
    const urlArr = split(decodeURI(location.href), '?', 2)
    const sParams = new URLSearchParams(urlArr.length > 1 ? urlArr[1].toString() : '')
    if (sParams.has('promo')) {
      setPromo(sParams.get('promo'))
    }

    if (isEmpty(currentTrip.car)) {
      // - only dispatch if car wasn't selected.
      // this will execute on first load
      dispatch(modelsActions.getCMSPartners())
      dispatch(modelsActions.getCMSLocations())
      dispatch(modelsActions.getCMSVehicles())
      dispatch(modelsActions.getCMSLocales())
      dispatch(modelsActions.getCMSRegions())
      dispatch(modelsActions.getCMSAges())
      dispatch(modelsActions.getCMSSwitchboards())
      dispatch(quotationActions.setQuotation({ data: { ...set(quotation, 'mode', mode) } }))
    }

    setupDateTime('useEffect[]')
    setPageLoaded(true)
  }, [])

  useEffect(() => {
    setPartner(find(partners, { mode }))
    setWidgetSkin({ ...widgetRules.getSkin(quotation.trip, quotation, partners, context, mode) })
  }, [partners])

  useEffect(() => {
    if (
      Object.keys(locales).length !== 0 &&
      (Object.keys(itineraryLbls).length === 0 || Object.keys(pagesLbls).length === 0)
    ) {
      // Objects Empty check
      setItineraryLbls(locales.itinerary[0])
      setPagesLbls(locales.pages[0])
    } else {
      // Empty Locales Object
    }
  }, [locales])

  useEffect(() => {
    if (
      Object.keys(ages).length !== 0 &&
      (driveAgeOptions.length < 1 || driveAgeOptions == undefined)
    ) {
      let optAge = []

      Object.keys(ages).forEach(key => {
        optAge.push({ label: ages[key].label, value: ages[key].value })
        if (ages[key].selected && !driverAge) {
          setDriverAge(ages[key].value)
        }
      })

      setDriveAgeOptions(optAge)
    }
  }, [ages])

  useEffect(() => {
    if (switchboards && Object.keys(switchboards).length !== 0) {
      // Objects Empty check
      setNzCrossIslandBookingAllowed(!!parseInt(switchboards.split_booking_active))
      setSplitbookingToSouthNotAllowed(
        !!parseInt(switchboards.split_booking_north_to_south_not_allowed),
      )
      setSplitbookingToNorthNotAllowed(
        !!parseInt(switchboards.split_booking_south_to_north_not_allowed),
      )
      setFerrybooking(!!parseInt(switchboards.ferry_booking_active))
    }
  }, [switchboards])

  useEffect(() => {
    if (pageLoaded) {
      if (Object.keys(relocation).length !== 0) setRelocationChecked(true)
    }
  }, [relocation])

  useEffect(() => {
    if (pageLoaded && !searchMode && relocationChecked) {
      alert('useEffect([relocationChecked]) -> getRates()')
      getRates()
    }
  }, [relocationChecked])

  useEffect(() => {
    if (pageLoaded && !searchMode && relocationChecked) {
      alert('useEffect([quotation.trips[1].rates, quotation.trips[2].rates])')
      getRates()
    }
    if (!searchMode && !availabilityCheck) {
      if (
        nzCrossIslandBooking &&
        quotation.trips[1].rates.default &&
        quotation.trips[2].rates.default
      ) {
        // Extra validation for Init Split Booking
        setAvailabilityCheck(true)
        checkAvailability()
      } else if (!nzCrossIslandBooking && quotation.trips[quotation.trip].rates[mode]) {
        setAvailabilityCheck(true)
        checkAvailability()
      }
    }
  }, [quotation.trips[1].rates, quotation.trips[2].rates])

  useEffect(() => {
    // Refresh

    if (refreshTrip != quotation.trip) {
      // setupLocations()
      setupDateTime('[quotation.trip, forceRefresh]')
      setRefreshTrip(quotation.trip)
    } else if (forceRefresh) {
      // Apply Code
      setForceRefresh(false)
    }
  }, [quotation.trip, forceRefresh])

  useEffect(() => {
    if (quotation.split) {
      // Splitbooking Date Selected Check
      switch (quotation.splitDateSelected) {
        case 0:
          if (quotation.trip == 1) {
            let info_message = 'Please select a Drop Off Date and Time for Trip 1 and Search.'
            addToast(info_message, {
              appearance: 'info',
              autoDismiss: true,
            })
          }
          break
        case 1:
          if (quotation.trip == 2) {
            let info_message = 'Please select a Pick Up Date and Time for Trip 2 and Search.'
            addToast(info_message, {
              appearance: 'info',
              autoDismiss: true,
            })
          }
          break
        case 2:
          // Continue Booking
          break
      }
    }
  }, [quotation.splitDateSelected])

  const setupLocationsConsolidated = () => {
    if (Object.keys(locations).length !== 0 && allLocations.length === 0) {
      let locationsArray = []

      Object.keys(locations).forEach(key => {
        locationsArray.push({
          label: locations[key].name,
          value: locations[key].code,
          country: locations[key].country,
          island: locations[key].island,
          hours: locations[key].hours,
          dropOffHours: locations[key].drop_off_hours,
        })
      })

      setAllLocations(locationsArray)

      if (quotation.split) {
        const pickupCode = quotation.trips[quotation.trip].pickup
        const dropoffCode = quotation.trips[quotation.trip].pickup
        setPickupLocation(
          Object.values(locationsArray).filter(location => location.value === pickupCode)[0],
        )
        setDropoffLocation(
          Object.values(locationsArray).filter(location => location.value === dropoffCode)[0],
        )
      } else if (!isEmpty(quotation.trips[quotation.trip].rates)) {
        const pickupCode = quotation.trips[quotation.trip].pickup
        setPickupLocation(
          Object.values(locationsArray).filter(location => location.value === pickupCode)[0],
        )
        setDropoffLocation(
          Object.values(locationsArray).filter(location => location.value === pickupCode)[0],
        )
      }

      if (!searchMode) {
        let url = new URL(location.href)
        let params = new URLSearchParams(url.search)
        let searchParam = params.get('type') != null ? true : false

        if (searchParam) {
          if (
            params.has('pickup') &&
            params.has('pickupDate') &&
            params.has('pickupTime') &&
            params.has('dropoff') &&
            params.has('dropoffDate') &&
            params.has('dropoffTime') &&
            params.has('driver') &&
            params.has('promo')
          ) {
            setSearchMode(true)
            setSearchParams(params)
          }
        }
      }
    }
  }

  const setupDateTime = caller => {
    if (loggingEnabled) console.log('[itinerary.js] ' + caller + ' -> setupDateTime')

    if (quotation.split) {
      const from = new Date(quotation.trips[quotation.trip].from)
      const until = new Date(quotation.trips[quotation.trip].until)

      setBookingDateTime({
        pickup: from,
        dropoff: until,
      })

      if (quotation.trip == 1) {
        setPickupMinDate(pickupTimes.validOpeningTime)
        setDropoffMinDate(from)
      } else {
        const firstUntil = new Date(quotation.trips[1].until)

        setPickupMinDate(firstUntil)
        setDropoffMinDate(firstUntil)
      }
    } else if (!isEmpty(quotation.trips[quotation.trip].rates)) {
      const from = new Date(quotation.trips[quotation.trip].from)
      const until = new Date(quotation.trips[quotation.trip].until)

      setBookingDateTime({
        pickup: from,
        dropoff: until,
      })

      const dropOffMinDate = new Date(from)
      dropOffMinDate.setDate(dropOffMinDate.getDate() + 1)
      setDropoffMinDate(dropOffMinDate)
    }
  }

  function createUrlParamsString() {
    // Extract url params from current URL,
    // Then writes state values into appropriate params, over-writing current values if they exist
    // Returns string of URL params

    let siteURL = new URL(location.href)
    let siteUrlParams = new URLSearchParams(siteURL.search)

    const newUrlParams = {
      pickup: pickupLocation.value,
      pickupDate: bookingDateTime.pickup,
      pickupTime: moment(bookingDateTime.pickup).format('HH:mm:00'),
      dropoff: dropoffLocation.value == 'same-0' ? pickupLocation.value : dropoffLocation.value,
      dropoffDate: bookingDateTime.dropoff,
      dropoffTime: moment(bookingDateTime.dropoff).format('HH:mm:00'),
      driver: driverAge,
      promo: searchPromocode,
    }

    for (const [key, value] of Object.entries(newUrlParams)) {
      siteUrlParams.set(key, value)
    }

    return siteUrlParams.toString()
  }

  const checkAvailability = () => {
    if (loggingEnabled)
      console.log('[itinerary.js] checkAvailability, clickedSearchFinal?: ' + clickedSearchFinal)
    if (clickedSearchFinal || true) {
      // bypass clickedSearchFinal
      setClickedSearchFinal(false)

      if (quotation.split) {
        setupDateTime('checkAvailability()') // Refresh Date Time selectors

        let { splitDateSelected } = quotation
        let { trip } = quotation
        if (pageLoaded && clickedSearchSplit) {
          if (quotation.trip == 1 && splitDateSelected == 0) {
            splitDateSelected++
            trip = 2
          } else if (quotation.trip == 2 && splitDateSelected == 1) {
            splitDateSelected++
            trip = 1
            let info_message = 'Please select a Vehicle for Trip 1.'
            addToast(info_message, {
              appearance: 'info',
              autoDismiss: true,
            })
          }
          setClickedSearchSplit(false)
        }

        if (!isEmpty(quotation.trips[quotation.trip].car)) {
          // Clear Vehicle Details and Change Phase
          dispatch(
            quotationActions.setQuotation({
              data: {
                ...quotation,
                phase: 'searchresult',
                splitDateSelected: splitDateSelected,
                trip: trip,
                trips: {
                  ...quotation.trips,
                  [quotation.trip]: {
                    ...quotation.trips[quotation.trip],
                    car: '',
                    initCar: '',
                    rid: '',
                  },
                },
              },
            }),
          )
        } else {
          // Change Phase
          dispatch(
            quotationActions.setQuotation({
              data: {
                ...quotation,
                phase: 'searchresult',
                splitDateSelected: splitDateSelected,
                trip: trip,
              },
            }),
          )
        }

        // Validation for Init Split Booking
        if (nzCrossIslandBooking) {
          // redirect to review/holding page
          if (!isEmpty(quotation.trips[quotation.trip].rates[quotation.mode])) {
            window.location = '/bookings/search'
          }
        } else {
          // Apply code for update and refresh review/holding page
          // Close Booking Widget
          // Update splitPhase in Global State to 'searchresult'
          // Display vehicle component
        }
      } else {
        if (loggingEnabled) console.log('[itinerary.js] checkAvailability, quotation not split')
        if (loggingEnabled) console.log(quotation.trips[quotation.trip].car)

        if (!isEmpty(quotation.trips[quotation.trip].car)) {
          if (loggingEnabled)
            console.log(
              '[itinerary.js] checkAvailability, quotation.trips[quotation.trip].car not empty',
            )
          // Clear Vehicle Details and Change Phase
          dispatch(
            quotationActions.setQuotation({
              data: {
                ...quotation,
                phase: 'searchresult',
                trips: {
                  ...quotation.trips,
                  [quotation.trip]: {
                    ...quotation.trips[quotation.trip],
                    car: '',
                    initCar: '',
                    rid: '',
                  },
                },
              },
            }),
          )
        } else if (quotation.phase !== 'searchresult') {
          // Change Phase
          dispatch(
            quotationActions.setQuotation({
              data: {
                ...quotation,
                phase: 'searchresult',
              },
            }),
          )
        }

        // New logic for hacky page redirect to search results page if we are NOT on that step
        // DISCLAIMER: I KNOW THIS IS MADNESS
        // If we have trip info from API - and we're not on search results page already, then true
        let redirectToSearchResults =
          !isEmpty(quotation.trips[quotation.trip].rates[quotation.mode]) &&
          !match('/bookings/search', location.pathname)

        if (redirectToSearchResults) {
          // Also setting search params in this step -> why wasn't this set before???
          const searchParams = createUrlParamsString()
          if (loggingEnabled)
            console.log('[itinerary.js] redirect to SRP?: ' + redirectToSearchResults)

          window.location = `/bookings/search?${searchParams}`
          if (loggingEnabled)
            console.log(`[itinerary.js] redirecting to: /bookings/search?${searchParams}`)
        }
      }
    }
  }

  const validate = () => {
    let pickupLoc = Object.values(locations).filter(
      location => location.code === pickupLocation.value,
    )[0]
    let msg = ''
    if (!driverAge) {
      msg = "Please Select Driver's Age"
    }

    if (
      pickupLoc &&
      pickupLoc.effectivedate &&
      pickupLoc.effectivedate != null &&
      pickupLoc.effectivedate != ''
    ) {
      let pickupDateFormatted = moment(bookingDateTime.pickup).format('YYYY-MM-DD')
      let formPickupDate = new Date(pickupDateFormatted)
      let effectiveDate = new Date(pickupLoc.effectivedate)

      if (formPickupDate < effectiveDate) {
        msg = 'This Location is only accepting bookings from ' + effectivedate + '.'
      }
    }

    if (mode != 'default') {
      const pd = moment(bookingDateTime.pickup.toJSON(), 'YYYY-MM-DDTHH:mm:ss.SSSZ')
      const dd = moment(bookingDateTime.dropoff.toJSON(), 'YYYY-MM-DDTHH:mm:ss.SSSZ')
      const min = pd.add(partner.minimum_days, 'd')

      if (min.isAfter(dd)) {
        msg = `This booking requires a minumum of ${partner.minimum_days} days`
      }
    }

    return msg
  }

  const onSearch = () => {
    if (loggingEnabled) console.log('[itinerary.js] clearing quotation')
    dispatch(modelsActions.clearQuotation())

    if (loggingEnabled)
      console.log('[itinerary.js] onSearch searchButtonClicked: ' + searchButtonClicked)

    setSearchButtonClicked(true)
    if (loggingEnabled)
      console.log('[itinerary.js] onSearch searchButtonClicked: ' + searchButtonClicked)

    splitBooking = dropoffLocation.value !== 'same-0'

    const pickupLocationObject = Object.values(locations).filter(
      location => location.code === pickupLocation.value,
    )[0]
    const dropoffLocationObject = Object.values(locations).filter(location =>
      location.code === splitBooking ? dropoffLocation.value : pickupLocation.value,
    )[0]

    let splitBooking, formDriver, formPromo, formDiscount

    if (loggingEnabled) console.log('[itinerary.js] searchMode: ' + searchMode)

    formDriver = driverAge
    formPromo = searchPromocode
    formDiscount = searchDiscountcode

    let pickupDay = bookingDateTime.pickup.getDay()
    if (loggingEnabled) console.log('[itinerary.js] pickupDay: ' + pickupDay)

    // Today Date Object and Formatted value
    let today = new Date()
    // Number of Booking Days
    let days =
      (bookingDateTime.dropoff.getTime() - bookingDateTime.pickup.getTime()) / (1000 * 3600 * 24)

    if (iframe && !searchMode) {
      if (loggingEnabled) console.log('iframe & not searchmode')
      // Bookings Search - Needs route and permalink url with search data
      let urlObj = {
        type: 'search',
        pickup: pickupLocation.value,
        pickupCtry: pickupLocation.country,
        pickupDate: moment(bookingDateTime.pickup).format('YYYY-MM-DDTHH:m:s'),
        pickupTime: moment(bookingDateTime.pickup).format('HH:m:s'),
        dropoff: splitBooking ? dropoffLocation.value : pickupLocation.value,
        dropoffCtry: splitBooking ? dropoffLocation.country : pickupLocation.country,
        dropoffDate: moment(bookingDateTime.dropoff).format('YYYY-MM-DDTHH:m:s'),
        dropoffTime: moment(bookingDateTime.dropoff).format('HH:m:s'),
        driver: formDriver,
        promo: formPromo,
        discount: formDiscount,
        searchType,
        promoCampaign,
        velocityabn,
        velocitynumber,
      }

      const urlGen = (urlObj, country, iframe) => {
        let url = window.location.host
        if (iframe && includes(url, 'blog.')) {
          url = replace(url, 'blog.', 'www.') // Won't need this when Blog integrated with website
        }

        return encodeURI(
          'http://' +
            url +
            '/bookings/search?' +
            Object.entries(urlObj)
              .map(([key, val]) => `${key}=${val}`)
              .join('&'),
        )
      }

      if (iframe) {
        window.parent.location = urlGen(urlObj, pickupCtry, iframe)
      } else {
        window.location = urlGen(urlObj, pickupCtry, iframe)
      }
    } else {
      if (loggingEnabled) console.log('[itinerary.js] searchmode & not iframe')
      let msg = validate()

      if (msg) {
        addToast(msg, {
          appearance: 'error',
          autoDismiss: true,
        })
        try {
          gtm.formErrorDisplay('start booking form', msg)
        } catch (error) {}
      } else {
        if (loggingEnabled) console.log('[itinerary.js] form validated')
        // - clear promocode check for next search
        // dispatch(modelsActions.clearPromocode())

        if (bookingDateTime.pickup <= today) {
          let error_message =
            'Sorry the Pickup time selected has lapsed. Please select a different Pickup time to book.'
          // let heading="Oops! Looks like something is missing!"
          // use custom popup with title
          addToast(error_message, {
            appearance: 'error',
            autoDismiss: true,
          })
          gtm.formErrorDisplay('start booking form', error_message)
        } else {
          if ((promo.toUpperCase() == 'IDP3K' || promo.toUpperCase() == 'IDP5K') && days < 30) {
            let error_message = 'Sorry the promocode is only valid with a minimum 30 days booking.'
            // let heading="Oops! Looks like something is missing!"
            // use custom popup with title
            addToast(error_message, {
              appearance: 'error',
              autoDismiss: true,
            })
            try {
              gtm.formErrorDisplay('start booking form', error_message)
            } catch (error) {}
            return false
          }

          let pickupOpeningHours = pickupLocation.hours.find(
            hrs =>
              hrs.day ==
              moment(bookingDateTime.pickup)
                .format('dddd')
                .toLowerCase(),
          )

          if (pickupOpeningHours) {
            let pickupDateFormatted = moment(bookingDateTime.pickup).format('YYYY-MM-DD')
            let openingTime = new Date(
              pickupDateFormatted + 'T' + pickupOpeningHours.opening_time + ':00',
            )
            let closingTime = new Date(
              pickupDateFormatted + 'T' + pickupOpeningHours.closing_time + ':00',
            )
            // Check for After Hours Pickup
            if (bookingDateTime.pickup < openingTime || bookingDateTime.pickup > closingTime)
              setAfterHourPickup(true)
          }

          if (afterHourPickup && quotation.mode == 'uber') {
            // Need to work on switching Modes (Default mode: home)
            let error_message =
              'Sorry This pick-up time falls outside of the Business hours of our Branch. Need help? Please Contact support@acerentalcars.' +
              (defaultCountry == 'nz' ? 'co.nz' : 'com.au')
            // let heading = "Oops! Looks like something is missing!"
            // use custom popup with title
            addToast(error_message, {
              appearance: 'error',
              autoDismiss: true,
            })
            try {
              gtm.formErrorDisplay('start booking form', error_message)
            } catch (error) {}
          } else {
            // Split Booking Notifications (NZ Inter-Island Bookings)
            if (
              nzCrossIslandBookingAllowed &&
              !quotation.split &&
              pickupLocation.country == 'nz' &&
              pickupLocation.island != dropoffLocation.island
            ) {
              if (
                promo.trim().toUpperCase() != 'RELOCATION' &&
                promo.trim().toUpperCase() != 'RELOCATIONS'
              ) {
                if (pickupLocation.island == 'north' && splitbookingToSouthNotAllowed) {
                  alert('Click OK to continue with one multi Island booking!')
                } else if (pickupLocation.island == 'south' && splitbookingToNorthNotAllowed) {
                  alert('Click OK to continue with one multi Island booking!')
                } else if (pickupLocation.island == 'north') {
                  alert(
                    'Save on Relocation Fees and the Cost of taking the vehicle on the ferry by making two bookings – drop your first hire off at our Wellington branch and then collect your second hire from our Picton branch!',
                  )
                  setNzCrossIslandBooking(true)
                } else if (pickupLocation.island == 'south') {
                  alert(
                    'Save on Relocation Fees and the Cost of taking the vehicle on the ferry by making two bookings – drop your first hire off at our Picton branch and then collect your second hire from our Wellington branch!',
                  )
                  setNzCrossIslandBooking(true)
                }
              } else if (pickupLocation.island == 'north') {
                if (splitbookingToNorthNotAllowed) {
                  alert(
                    'Unfortunately, a multi Island booking from North to South island is not permitted! However you can create two bookings one booking with a drop off location of Wellington and the second booking with a pickup in Picton.',
                  )
                  return false
                } else {
                  // Continue
                }
              } else if (pickupLocation.island == 'south') {
                if (splitbookingToSouthNotAllowed) {
                  alert(
                    'Unfortunately, a multi Island booking from South to North island is not permitted! However you can create two bookings one booking with a drop off location of Picton and the second booking with a pickup in Wellington.',
                  )
                  return false
                } else {
                  // Continue
                }
              }
            }

            let rtnLocation = dropoffLocation.value == 'same-0' ? pickupLocation : dropoffLocation

            if (loggingEnabled) console.log('[itinerary.js] setting new form data for search')

            setRelocationChecked(false) // UseEffect line 367 if true getRates()
            setAvailabilityCheck(false)
            getRates()

            const nowMoment = moment()
            const bookingPickup = moment(bookingDateTime.pickup)
            const bookingDropoff = moment(bookingDateTime.dropoff)

            gtm.startSearch({
              Event: 'rental_search',
              pickUpLocationCode: pickupLocation.value, //{{pick up location Licensee/ Corporate}},
              dropoffLocationCode: rtnLocation.value, //{{drop off location Licensee/ Corporate}},
              pickupCity: pickupLocationObject.name, //{{pick up location}},
              dropoffCity: dropoffLocationObject.name, //{{drop off location}},
              pickupDate_mmddyy: bookingPickup.format('dd/mm/yy'), //{{pickup date}},
              dropoffDate_mmddyy: bookingDropoff.format('dd/mm/yy'), //{{drop off date}},
              pickupCountryCode: pickupLocationObject.country, //{{pick up country}},
              dropoffCountryCode: dropoffLocationObject.country, //{{drop off country}},
              pickupDoW: bookingPickup.format('dddd'), //{{pick up day of the week}},
              dropoffDoW: bookingDropoff.format('dddd'), //{{drop off day of the week}},
              pickupMonth_mm: bookingPickup.format('MMM'), //{{pick up month}},
              dropoffMonth_mm: bookingDropoff.format('MMM'), //{{drop off month}},
              pickupState: pickupLocationObject.gs_region, //{{pick up state}},
              dropoffState: dropoffLocationObject.gs_region, //{{drop off state}},
              pickupTime24HR: bookingPickup.format('HH:mm'), //{{pick up time in 24 HR format}},
              dropoffTime24HR: bookingDropoff.format('HH:mm'), //{{drop off time in 24 HR format}},
              pickupYear_yyyy: bookingPickup.format('YYYY'), //{{pick up year}},
              dropoffYear_yyyy: bookingDropoff.format('YYYY'), //{{drop off year}},
              pickupOAGCode: '', //{{pick up state}},
              dropoffOAGCode: '', //{{drop off state}},
              rentalDays: Math.abs(bookingPickup.diff(bookingDropoff, 'days')), //{{number of days of rental}},
              isDomestic: true, //{{true or false}},
              isOneWay: pickupLocation.value !== rtnLocation.value, //{{return or one-way}},
              bookingWindow: Math.abs(nowMoment.diff(bookingPickup, 'days')), //{{number of days until rental starts}},
              ageRange: driverAge, //{{age range}}
            })
          }
        }
      }
    }
  }

  const getRates = () => {
    if (loggingEnabled)
      console.log('[itinerary.js] getRates searchButtonClicked: ' + searchButtonClicked)
    if (loggingEnabled)
      console.log('[itinerary.js] getRates clickedSearchFinal: ' + clickedSearchFinal)
    // Manage Events after Search Clicked
    if (!pickupLocation) return

    if (searchButtonClicked) {
      if (quotation.phase == 'searchresult' && match('/bookings', location.pathname)) {
        setClickedSearchSplit(true)
      }
      setClickedSearchFinal(true)
    }

    setSearchButtonClicked(false)

    // Same Location Flag
    let splitBooking = dropoffLocation.value !== 'same-0'
    let depositAllowed = true

    if (!isEmpty(promo) && has(promocode, 'CDP')) {
      const isblackoutdates = promocode.blackoutdates.filter((bdr, i) => {
        if (moment(bookingDateTime.pickup.toJSON()).isBetween(bdr.from, bdr.to)) {
          return true
        }

        return false
      })

      let blackoutL = []
      if (!isEmpty(promocode.blackoutlocations) && promocode.blackoutlocations != 0) {
        blackoutL = map(promocode.blackoutlocations, locID => {
          return find(locations, { id: parseInt(locID) }) !== undefined
            ? find(locations, { id: parseInt(locID) }).code
            : ''
        })
      }

      const isblackoutlocations = () => {
        if (!isEmpty(blackoutL)) {
          return indexOf(blackoutL, pickupLocation.value) != -1
        }

        return false
      }

      if (!isEmpty(promocode.blackoutdates) && !isEmpty(isblackoutdates)) {
        let error_message = 'Sorry, this promocode is not applicable for this date.'
        addToast(error_message, {
          appearance: 'error',
          autoDismiss: true,
        })
        gtm.formErrorDisplay('start booking form', error_message)

        return false
      } else if (isblackoutlocations()) {
        let error_message = 'Sorry, this promocode is not applicable for this location.'
        addToast(error_message, {
          appearance: 'error',
          autoDismiss: true,
        })
        gtm.formErrorDisplay('start booking form', error_message)

        return false
      } else if (
        promocode.minimumdays > 0 &&
        Math.abs(
          moment(bookingDateTime.pickup.toJSON(), 'YYYY-MM-DD').diff(
            moment(bookingDateTime.dropoff.toJSON(), 'YYYY-MM-DD'),
            'days',
          ),
        ) < promocode.minimumdays
      ) {
        let error_message = `This promocode is not applicable for a booking that has less than ${promocode.minimumdays} days.`
        addToast(error_message, {
          appearance: 'error',
          autoDismiss: true,
        })
        gtm.formErrorDisplay('start booking form', error_message)

        return false
      } else if (
        promocode.maximumdays > 0 &&
        Math.abs(
          moment(bookingDateTime.pickup.toJSON(), 'YYYY-MM-DD').diff(
            moment(bookingDateTime.dropoff.toJSON(), 'YYYY-MM-DD'),
            'days',
          ),
        ) > promocode.maximumdays
      ) {
        let error_message = `This promocode is not applicable for a booking that has more than ${promocode.maximumdays} days.`
        addToast(error_message, {
          appearance: 'error',
          autoDismiss: true,
        })
        gtm.formErrorDisplay('start booking form', error_message)

        return false
      }

      if (quotation.mode != 'travelpartner' && promocode.depositnotallowed) {
        depositAllowed = false
      }
    }

    const splitBookingLocations = {
      north: Object.values(locations).filter(location => location.code === 'ACW60')[0], // Wellington City
      south: Object.values(locations).filter(location => location.code === 'ACP60')[0], // Picton
    }

    if (nzCrossIslandBooking) {
      // Booking country is NZ and trip is split across north/south islands

      // Validation
      const firstIsland = pickupLocation.island
      const secondIsland = dropoffLocation.island

      let firstIslandDropoff = splitBookingLocations[pickupLocation.island]
      let secondIslandPickup = splitBookingLocations[dropoffLocation.island]

      let firstPickupDateTime = moment(bookingDateTime.pickup.toJSON()).format(
        'YYYY-MM-DD HH:mm:ss',
      )
      let firstDropoffDateTime = moment(bookingDateTime.pickup.toJSON())
        .add(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss')

      let secondPickupDateTime = moment(bookingDateTime.dropoff.toJSON())
        .subtract(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss')
      let secondDropoffDateTime = moment(bookingDateTime.dropoff.toJSON()).format(
        'YYYY-MM-DD HH:mm:ss',
      )

      if (firstDropoffDateTime > secondPickupDateTime) {
        secondPickupDateTime = moment(firstDropoffDateTime)
          .add(60, 'minutes')
          .format('YYYY-MM-DD HH:mm:ss')
        secondDropoffDateTime = moment(secondPickupDateTime)
          .add(1, 'day')
          .format('YYYY-MM-DD HH:mm:ss')
      }

      const form = {
        [1]: {
          pickup: pickupLocation.value,
          pickupCtry: 'nz',
          pickupIsland: firstIsland,
          return: firstIslandDropoff.code,
          returnCtry: 'nz',
          returnIsland: firstIsland,
          from:
            moment(firstPickupDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(firstPickupDateTime).format('HH:mm:ss'),
          until:
            moment(firstDropoffDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(firstDropoffDateTime).format('HH:mm:ss'),
          dob: driverAge,
          promo: searchPromocode,
          discount: searchDiscountcode,
          ITCode: searchITCode,
          iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
          cdp: '',
          afterHoursPickup: afterHourPickup,
          searchType,
          autoClubActive,
          autoclubmembershiptype,
          autoclubmembership,
          blueChipMembershipActive,
          bluechipname,
          bluechipnumber,
          promoCampaign,
          velocityabn,
          velocitynumber,
        },
        [2]: {
          pickup: secondIslandPickup.code,
          pickupCtry: 'nz',
          pickupIsland: secondIsland,
          return: dropoffLocation.value,
          returnCtry: 'nz',
          returnIsland: secondIsland,
          from:
            moment(secondPickupDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(secondPickupDateTime).format('HH:mm:ss'),
          until:
            moment(secondDropoffDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(secondDropoffDateTime).format('HH:mm:ss'),
          dob: driverAge,
          promo: searchPromocode,
          discount: searchDiscountcode,
          ITCode: searchITCode,
          iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
          cdp: '',
          afterHoursPickup: afterHourPickup,
          searchType,
          autoClubActive,
          autoclubmembershiptype,
          autoclubmembership,
          blueChipMembershipActive,
          bluechipname,
          bluechipnumber,
          promoCampaign,
          velocityabn,
          velocitynumber,
        },
      }

      dispatch(
        quotationActions.setQuotation({
          data: {
            ...quotation,
            country: defaultCountry,
            split: true,
            depositAllowed: depositAllowed,
            trips: {
              ...quotation.trips,
              [1]: {
                ...quotation.trips[1],
                ...form[1],
                promo: searchPromocode,
                discount: searchDiscountcode,
                ITCode: searchITCode,
                iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
                autoClubActive,
                autoclubmembershiptype,
                autoclubmembership,
                blueChipMembershipActive,
                bluechipname,
                bluechipnumber,
                promoCampaign,
                velocityabn,
                velocitynumber,
                searchType,
                cdp: !isEmpty(promocode) && has(promocode, 'CDP') ? promocode.CDP : '',
              },
              [2]: {
                ...quotation.trips[2],
                ...form[2],
                promo: searchPromocode,
                discount: searchDiscountcode,
                ITCode: searchITCode,
                iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
                autoClubActive,
                autoclubmembershiptype,
                autoclubmembership,
                blueChipMembershipActive,
                bluechipname,
                bluechipnumber,
                promoCampaign,
                velocityabn,
                velocitynumber,
                searchType,
                cdp: !isEmpty(promocode) && has(promocode, 'CDP') ? promocode.CDP : '',
              },
            },
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: 1, // Added Value for Split Booking
            ref: uuidv4(),
            ...form[1],
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: 2, // Added Value for Split Booking
            ref: uuidv4(),
            ...form[2],
          },
        }),
      )
    } else if (quotation.split) {
      // Continue Split Booking
      const firstIsland =
        quotation.trip == 1 ? pickupLocation.island : quotation.trips[1].pickupIsland
      const secondIsland =
        quotation.trip == 1 ? quotation.trips[2].pickupIsland : pickupLocation.island

      let firstIslandDropoff = splitBookingLocations[firstIsland]
      let secondIslandPickup = splitBookingLocations[secondIsland]

      let firstPickup = quotation.trip == 1 ? pickupLocation.value : quotation.trips[1].pickup
      let secondDropoff = quotation.trip == 1 ? quotation.trips[2].return : dropoffLocation.value

      let firstPickupDateTime =
        quotation.trip == 1
          ? moment(bookingDateTime.pickup.toJSON()).format('YYYY-MM-DD HH:mm:ss')
          : moment(quotation.trips[1].from).format('YYYY-MM-DD HH:mm:ss')
      let firstDropoffDateTime =
        quotation.trip == 1
          ? moment(bookingDateTime.dropoff.toJSON()).format('YYYY-MM-DD HH:mm:ss')
          : moment(quotation.trips[1].until).format('YYYY-MM-DD HH:mm:ss')

      let secondPickupDateTime =
        quotation.trip == 2
          ? moment(bookingDateTime.pickup.toJSON()).format('YYYY-MM-DD HH:mm:ss')
          : moment(quotation.trips[2].from).format('YYYY-MM-DD HH:mm:ss')
      let secondDropoffDateTime =
        quotation.trip == 2
          ? moment(bookingDateTime.dropoff.toJSON()).format('YYYY-MM-DD HH:mm:ss')
          : moment(quotation.trips[2].until).format('YYYY-MM-DD HH:mm:ss')

      if (firstDropoffDateTime >= secondPickupDateTime) {
        if (quotation.trip == 1) {
          // Adjust Trip 1
          firstDropoffDateTime = moment(secondPickupDateTime)
            .subtract(60, 'minutes')
            .format('YYYY-MM-DD HH:mm:ss')
        } else {
          // Adjust Trip 2
          secondPickupDateTime = moment(firstDropoffDateTime)
            .add(60, 'minutes')
            .format('YYYY-MM-DD HH:mm:ss')
        }
      }

      const form = {
        [1]: {
          pickup: firstPickup,
          pickupIsland: firstIsland,
          return: firstIslandDropoff.code,
          returnIsland: firstIsland,
          from:
            moment(firstPickupDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(firstPickupDateTime).format('HH:mm:ss'),
          until:
            moment(firstDropoffDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(firstDropoffDateTime).format('HH:mm:ss'),
          dob: driverAge,
          promo: searchPromocode,
          discount: searchDiscountcode,
          ITCode: searchITCode,
          iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
          autoClubActive,
          autoclubmembershiptype,
          autoclubmembership,
          blueChipMembershipActive,
          bluechipname,
          bluechipnumber,
          promoCampaign,
          velocityabn,
          velocitynumber,
          searchType,
          cdp: '',
          afterHoursPickup: afterHourPickup,
        },
        [2]: {
          pickup: secondIslandPickup.code,
          pickupIsland: secondIsland,
          return: secondDropoff,
          returnIsland: secondIsland,
          from:
            moment(secondPickupDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(secondPickupDateTime).format('HH:mm:ss'),
          until:
            moment(secondDropoffDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(secondDropoffDateTime).format('HH:mm:ss'),
          dob: driverAge,
          promo: searchPromocode,
          discount: searchDiscountcode,
          ITCode: searchITCode,
          iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
          autoClubActive,
          autoclubmembershiptype,
          autoclubmembership,
          blueChipMembershipActive,
          bluechipname,
          bluechipnumber,
          promoCampaign,
          velocityabn,
          velocitynumber,
          searchType,
          cdp: '',
          afterHoursPickup: afterHourPickup,
        },
      }

      dispatch(
        quotationActions.setQuotation({
          data: {
            ...quotation,
            trips: {
              ...quotation.trips,
              [1]: {
                ...quotation.trips[1],
                ...form[1],
                promo: searchPromocode,
                discount: searchDiscountcode,
                ITCode: searchITCode,
                iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
                autoClubActive,
                autoclubmembershiptype,
                autoclubmembership,
                blueChipMembershipActive,
                bluechipname,
                bluechipnumber,
                promoCampaign,
                velocityabn,
                velocitynumber,
                searchType,
                cdp: !isEmpty(promocode) && has(promocode, 'CDP') ? promocode.CDP : '',
              },
              [2]: {
                ...quotation.trips[2],
                ...form[2],
                promo: searchPromocode,
                discount: searchDiscountcode,
                ITCode: searchITCode,
                iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
                autoClubActive,
                autoclubmembershiptype,
                autoclubmembership,
                blueChipMembershipActive,
                bluechipname,
                bluechipnumber,
                promoCampaign,
                velocityabn,
                velocitynumber,
                searchType,
                cdp: !isEmpty(promocode) && has(promocode, 'CDP') ? promocode.CDP : '',
              },
            },
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: 1, // Added Value for Split Booking
            ref: uuidv4(),
            ...form[1],
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: 2, // Added Value for Split Booking
            ref: uuidv4(),
            ...form[2],
          },
        }),
      )
    } else {
      // Single Booking OR Split Booking after initial booking has been separated
      const form = {
        pickup: pickupLocation.value,
        pickupIsland: pickupLocation.island,
        return: splitBooking ? dropoffLocation.value : pickupLocation.value,
        returnIsland: splitBooking ? dropoffLocation.island : pickupLocation.island,
        from: moment(bookingDateTime.pickup).format('YYYY-MM-DD HH:mm:00'),
        until: moment(bookingDateTime.dropoff).format('YYYY-MM-DD HH:mm:00'),
        dob: driverAge,
        promo: searchPromocode,
        discount: searchDiscountcode,
        ITCode: searchITCode,
        iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
        autoClubActive,
        autoclubmembershiptype,
        autoclubmembership,
        blueChipMembershipActive,
        bluechipname,
        bluechipnumber,
        promoCampaign,
        velocityabn,
        velocitynumber,
        searchType,
        cdp: '',
        afterHoursPickup: afterHourPickup,
      }

      dispatch(
        quotationActions.setQuotation({
          data: {
            ...quotation,
            country: defaultCountry,
            split: false,
            depositAllowed: depositAllowed,
            trips: {
              ...quotation.trips,
              [quotation.trip]: {
                ...quotation.trips[quotation.trip],
                ...form,
                promo: searchPromocode,
                discount: searchDiscountcode,
                ITCode: searchITCode,
                iata: getCookie('loggedIn') === 'true' ? getCookie('iataCode') : '',
                autoClubActive,
                autoclubmembershiptype,
                autoclubmembership,
                blueChipMembershipActive,
                bluechipname,
                bluechipnumber,
                promoCampaign,
                velocityabn,
                velocitynumber,
                searchType,
                cdp: !isEmpty(promocode) && has(promocode, 'CDP') ? promocode.CDP : '',
              },
            },
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: quotation.trip, // Added Value for Split Booking
            ref: uuidv4(),
            ...form,
          },
        }),
      )
    }
  }

  const saveDataForLater = () => {
    const bookingData = {}
    if (pickupLocation.value) bookingData.pickupLocation = pickupLocation
    if (dropoffLocation && dropoffLocation.value !== 'same-0')
      bookingData.dropoffLocation = dropoffLocation
    if (bookingDateTime.pickup) bookingData.pickupDate = bookingDateTime.pickup
    if (bookingDateTime.dropoff) bookingData.dropoffDate = bookingDateTime.dropoff
    if (driverAge) bookingData.driverAge = driverAge

    localStorage.setItem('bookingData', JSON.stringify(bookingData))
  }

  const [bookingDataPopulated, setBookingDataPopulated] = useState(false)
  // emre -- update
  useEffect(() => {
    try {
      if (
        locations &&
        Object.keys(locations).length !== 0 &&
        Object.keys(itineraryLbls).length !== 0 &&
        !bookingDataPopulated &&
        localStorage.getItem('bookingData')
      ) {
        const bookingData = JSON.parse(localStorage.getItem('bookingData'), true)
        if (bookingData.pickupLocation) {
          setPickupLocation(bookingData.pickupLocation)
        }
        if (bookingData.dropoffLocation) {
          setDropoffLocation(bookingData.dropoffLocation)
        }
        if (bookingData.pickupDate && bookingData.dropoffDate) {
          setBookingDateTime({
            pickup: new Date(bookingData.pickupDate),
            dropoff: new Date(bookingData.dropoffDate),
          })
        }
        if (bookingData.driverAge) {
          setDriverAge(bookingData.driverAge)
        }
        localStorage.removeItem('bookingData')
        setBookingDataPopulated(true)
      }
    } catch (error) {
      if (loggingEnabled) console.log(error)
    }
  }, [locations, itineraryLbls, bookingDataPopulated])

  const toggleDropoffLocation = visible => {
    if (!visible) {
      // Update Value
      setDropoffLocation({
        label: Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.same_as_pickup : '',
        value: 'same-0',
        country: '',
        hours: null,
        drop_off_hours: null,
      })
    }
  }

  const handleMinimumAgeChange = optionSelected => {
    setDriverAge(optionSelected.value)
  }

  function dateToNearestHalfHour(date = false) {
    if (!date) date = new Date()
    const dateMins = date.getMinutes()

    if (dateMins != 30 && dateMins != 0) {
      const remainder =
        60 - dateMins > 30 ? (30 - dateMins) * 60 * 1000 : (60 - dateMins) * 60 * 1000

      date.setTime(date.getTime() + remainder)
    }
    return date
  }

  const handlePickUpLocationChange = (optionSelected, actionMeta) => {
    handleDateTimeChange('pickup', null)
    if (dropoffLocation.value === 'same-0') handleDateTimeChange('dropoff', null)

    switch (actionMeta.action) {
      case 'select-option':
        setPickupLocation(optionSelected)
        break

      case 'clear':
        setPickupLocation({
          label: 'Enter location',
          value: '',
          country: '',
          hours: null,
          drop_off_hours: null,
        })

        document.querySelector('#formPickupLocation input').focus()
        break
    }
  }

  const handleDropOffLocationChange = (optionSelected, actionMeta) => {
    handleDateTimeChange('dropoff', null)

    switch (actionMeta.action) {
      case 'select-option':
        setDropoffLocation(optionSelected)
        break

      case 'clear':
        setDropoffLocation({
          label: 'Enter drop-off location',
          value: 'same-0',
          country: '',
          hours: null,
          drop_off_hours: null,
        })

        document.querySelector('#formDropoffLocation input').focus()
        break
    }
  }

  const selectTrip = newTrip => {
    if (quotation.trip != newTrip) {
      if (quotation.splitDateSelected == 0 && quotation.trip == 1) {
        alert(`Please select a Drop Off Date and Time for Trip 1 and Search.`)
      } else if (quotation.splitDateSelected == 1 && quotation.trip == 2) {
        alert(`Please select a Pick Up Date and Time for Trip 2 and Search.`)
      } else if (isEmpty(quotation.trips[quotation.trip].car)) {
        alert(`Please select a Vehicle for Trip ${quotation.trip}`)
      } else if (!isEmpty(quotation.trips[newTrip].res)) {
        alert(`Please complete Payment of Trip ${quotation.trip}`)
      } else {
        dispatch(
          quotationActions.setQuotation({
            data: {
              ...quotation,
              trip: newTrip,
            },
          }),
        )
        setWidgetSkin({ ...widgetRules.getSkin(newTrip, quotation, models, context, mode) })
      }
    }
  }

  let widgetOpen =
    location.pathname == '/' ||
    match('/locations/', location.pathname) ||
    match('/experience/', location.pathname) ||
    (match('/bookings/*', location.pathname) && quotation.phase == 'searchresult')

  let widgetLocked =
    location.pathname == '/' ||
    match('/locations/', location.pathname) ||
    match('/experience/', location.pathname) ||
    match('/bookings/search', location.pathname)

  // Force Widget Open and Locked
  if (
    !match('/bookings/', location.pathname) &&
    quotation.split &&
    quotation.splitDateSelected < 2
  ) {
    widgetOpen = true
    widgetLocked = true
  }

  widgetLocked = !isEmpty(quotation.trips[quotation.trip].res)

  useEffect(() => {
    // Fuck this mess. Tried to clean up a bit but it's still horrible.
    const urlParams = new URLSearchParams(window.location.search)
    const getCdppromo = urlParams.get('cdppromo')
    const getPromo = urlParams.get('promo')
    const getCdpCampaign = urlParams.get('cdpCampaign')
    const velocityAbnString =
      sessionStorage.getItem('velocityABN') || urlParams.get('member-id') || false
    const velocityPromo = getCookie('velocityPromo')
      ? JSON.parse(getCookie('velocityPromo'))
      : false

    let campaign = velocityPromo?.campaign || ''
    let discountCode = velocityPromo?.discountCode || ''
    let url = window.location.href

    setWidgetForceOpen(velocityPromo || getPromo || getCdppromo)
    if (getCdpCampaign) setPromoCampaign(getCdpCampaign.toLowerCase())

    if (velocityPromo) {
      setPromoCampaign(campaign)
      setSearchDiscountcode(discountCode)
    } else {
      if (getPromo) setSearchPromocode(getPromo.replace(/[^0-9a-zA-Z_-]/gi, ''))
      if (getCdppromo) setSearchDiscountcode(getCdppromo.replace(/[^0-9a-zA-Z_-]/gi, ''))
    }

    if (velocityAbnString) {
      sessionStorage.setItem('velocityABN', velocityAbnString)
      setVelocityAbn(velocityAbnString)
    }

    if (defaultCountry === 'nz') {
      if (url.includes('/aa-members')) {
        campaign = 'aa-members'
        discountCode = '2227897'
      } else if (url.includes('/aa-smartfuel')) {
        campaign = 'aa-smartfuel'
        discountCode = '3500007'
      } else if (url.includes('/vabf') || url.includes('/virginaustraliabusinessflyer')) {
        campaign = 'velocity-promo'
        discountCode = '3500010'
      }
    } else if (
      defaultCountry === 'au' &&
      (url.includes('/vabf') || url.includes('/virginaustraliabusinessflyer'))
    ) {
      campaign = 'velocity-promo'
      discountCode = '3500010'
    }

    if (discountCode !== '') {
      const date = new Date()
      setWidgetForceOpen(true)
      setSearchDiscountcode(discountCode)
      setPromoCampaign(campaign)

      if (velocityAbnString && velocityAbnString !== '') {
        setCookie(
          'velocityPromo',
          JSON.stringify({ campaign, discountCode, velocityAbnString }),
          0.25,
        )
        setCookie('velocityPromoExpireTime', date.getTime() + 0.25 * 60 * 60 * 1000, 0.25)
        const url = new URL(window.location)
        url.searchParams.set('signature', '')
        window.history.pushState({}, '', url)
      }
    }
  }, [defaultCountry])

  return (
    <>
      <CookieTimeOutPopup />
      <div
        id="booknow"
        style={{
          backgroundColor: 'rgba(0, 122, 195, 1)',
          padding: window.innerWidth < 1200 ? '30px 0 0' : '60px 0 0',
        }}
      >
        <div>
          {quotation.split && match('/bookings/', location.pathname) ? (
            <BookingSplitTitleBar
              bgColor={widgetSkin.bgColorLight}
              widgetOpen={
                widgetCtxOpen ||
                (widgetForceOpen && window.innerWidth > 1200) ||
                (widgetOpen && window.innerWidth > 1200)
              }
              widgetLocked={widgetLocked}
              titleOne={'Trip 1'}
              titleTwo={'Trip 2'}
              trip={quotation.trip}
              selectTrip={selectTrip}
              carOneSelected={!isEmpty(quotation.trips[1].car)}
              carTwoSelected={!isEmpty(quotation.trips[2].car)}
              tripOnePaid={!isEmpty(quotation.trips[1].res)}
              tripTwoPaid={!isEmpty(quotation.trips[2].res)}
            ></BookingSplitTitleBar>
          ) : (
            <BookingTitleBar
              searchType={searchType}
              setSearchType={setSearchType}
              bgColor={widgetSkin.bgColorLight}
              widgetOpen={
                widgetCtxOpen ||
                (widgetForceOpen && window.innerWidth > 1200) ||
                (widgetOpen && window.innerWidth > 1200)
              }
              widgetLocked={widgetLocked}
            >{`${widgetSkin.header}`}</BookingTitleBar>
          )}
        </div>
        <BookingWidget
          promoCampaign={promoCampaign}
          onCampaignClick={() => {
            saveDataForLater()
          }}
          bgColor={widgetSkin.bgColor}
          widgetOpen={
            widgetCtxOpen ||
            (widgetForceOpen && window.innerWidth > 1200) ||
            (widgetOpen && window.innerWidth > 1200)
          }
          setSearchDiscountcode={setSearchDiscountcode}
          widgetLocked={widgetLocked}
          setBlueChipMemberDropdown={setBlueChipMemberDropdown}
          blueChipMemberDropdown={blueChipMemberDropdown}
          bluechipWrapperRef={bluechipWrapperRef}
          bluechipnumber={bluechipnumber}
          setbluechipnumber={setbluechipnumber}
          setVelocityDropdown={setVelocityDropdown}
          velocityDropdown={velocityDropdown}
          velocityWrapperRef={velocityWrapperRef}
          velocitynumber={velocitynumber}
          setvelocitynumber={setvelocitynumber}
          bluechipname={bluechipname}
          setbluechipname={setbluechipname}
          setAutoClubDropdown={setAutoClubDropdown}
          autoClubDropdown={autoClubDropdown}
          autoclubWrapperRef={autoclubWrapperRef}
          autoclubmembership={autoclubmembership}
          setautoclubmembership={setautoclubmembership}
          autoclubmembershiptype={autoclubmembershiptype}
          setautoclubmembershiptype={setautoclubmembershiptype}
          blueChipMembershipActive={blueChipMembershipActive}
          setblueChipMembershipActive={setblueChipMembershipActive}
          autoClubActive={autoClubActive}
          setautoClubActive={setautoClubActive}
        >
          <BookingColumn minWidth="300px" marginRight="10px">
            <Boxes>
              <BookingWidgetTitle>
                {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.pickup_location : ''}
              </BookingWidgetTitle>
              <LocationSelect
                name="formPickupLocation"
                pickupLocation={pickupLocation}
                pickupOptions={allLocations}
                selectHandleChange={handlePickUpLocationChange}
                isDisabled={!widgetSkin.pickupLocation}
                isLoading={false}
              />
            </Boxes>
            {widgetSkin.returnLocationToggle ? (
              <>
                <BookingPickupAccordion toggleDropoffLocation={toggleDropoffLocation}>
                  <BookingWidgetTitle>
                    {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.dropoff_location : ''}
                  </BookingWidgetTitle>
                  <LocationSelect
                    name="formDropoffLocation"
                    pickupLocation={dropoffLocation}
                    pickupOptions={allLocations}
                    selectHandleChange={handleDropOffLocationChange}
                    isDisabled={!widgetSkin.returnLocation}
                    isLoading={false}
                  />
                </BookingPickupAccordion>
                {pickupLocation.country &&
                  dropoffLocation.country &&
                  dropoffLocation.country !== '' &&
                  pickupLocation.country != dropoffLocation.country && (
                    <div
                      style={{
                        color: '#fff',
                        display: 'flex',
                        fontSize: '12px',
                        alignItems: 'center',
                        paddingTop: '7px',
                      }}
                    >
                      <img
                        src="/themes/thrifty/assets/images/form-error.svg"
                        style={{ width: '12px', height: '12px', marginRight: '5px' }}
                      />
                      Drop-off location is in a different country
                    </div>
                  )}
              </>
            ) : (
              <div style={{ paddingTop: 15 }}>
                <Boxes>
                  <BookingWidgetTitle>
                    {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.dropoff_location : ''}
                  </BookingWidgetTitle>
                  <LocationSelect
                    name="formDropoffLocation"
                    pickupLocation={dropoffLocation}
                    pickupOptions={allLocations}
                    selectHandleChange={handleDropOffLocationChange}
                    isDisabled={!widgetSkin.returnLocation}
                    isLoading={false}
                  />
                </Boxes>
              </div>
            )}
          </BookingColumn>
          <BookingColumn marginRight="10px">
            <Boxes>
              <BookingWidgetTitle>
                {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.pickup_date : ''}
              </BookingWidgetTitle>
              <DateTimeSelect
                name="formPickupDateTime"
                onDateChange={date => handleDateTimeChange('pickup', date)}
                date={bookingDateTime.pickup}
                minDate={pickupMinDate}
                location={pickupLocation}
                locationType="pickup"
              />
            </Boxes>
          </BookingColumn>
          <BookingColumn marginRight="10px">
            <Boxes>
              <BookingWidgetTitle>
                {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.dropoff_date : ''}
              </BookingWidgetTitle>
              <DateTimeSelect
                name="formDropoffDateTime"
                onDateChange={date => handleDateTimeChange('dropoff', date)}
                date={bookingDateTime.dropoff}
                minDate={dropoffMinDate}
                location={dropoffLocation.hours ? dropoffLocation : pickupLocation}
                locationType="dropoff"
              />
            </Boxes>
          </BookingColumn>
          <BookingColumn minWidth="150px" maxWidth="175px" marginRight="10px">
            <Boxes>
              <BookingWidgetTitle>
                {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.driver_age : ''}
              </BookingWidgetTitle>
              <AgeSelect
                name="formMinimumAge"
                driverAge={driverAge}
                driveAgeOptions={driveAgeOptions}
                selectHandleChange={handleMinimumAgeChange}
                isDisabled={!widgetSkin.age}
                isLoading={false}
              />
            </Boxes>
          </BookingColumn>
          <BookingColumn
            minWidth="150px"
            maxWidth="175px"
            marginRight="10px"
            display={promoCampaign === 'velocity-promo' ? 'none' : undefined}
          >
            <div style={{ position: 'relative' }}>
              <Boxes>
                <BookingWidgetTitle disabled={!widgetSkin.promocode}>
                  {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.promocode : ''}
                </BookingWidgetTitle>
                <a
                  className={classes.PromoCodeLauncher}
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    setPromoDropdown.true()
                  }}
                >
                  {searchDiscountcode === '' && searchPromocode === '' && 'Add promo code'}
                  {searchDiscountcode === '' && searchPromocode !== '' && `${searchPromocode}`}
                  {searchDiscountcode !== '' && searchPromocode === '' && `${searchDiscountcode}`}
                  {searchDiscountcode !== '' && searchPromocode !== '' && 'Promo codes added'}
                </a>
                {promoDropdown && (
                  <div
                    ref={promoWrapperRef}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      background: '#fff',
                      zIndex: 1,
                      padding: '8px 8px 0 8px',
                      border: '1px solid #ccc',
                      borderTop: 0,
                      boxShadow: '2px 10px 30px rgba(0, 0, 0, 0.25)',
                      borderRadius: '20px',
                      boxSizing: 'border-box',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '15px',
                        marginTop: '2px',
                        marginLeft: '6px',
                        marginBottom: '0px',
                        fontFamily: 'TTRounds',
                        fontWeight: '500',
                        textAlign: 'left',
                        color: 'rgb(51, 51, 51)',
                        opacity: '1',
                      }}
                    >
                      Promo Code
                    </div>
                    <div style={{ padding: '15px 8px 0 8px' }}>
                      <div
                        style={{
                          fontStyle: 'normal',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: 1.4,
                          marginBottom: 7,
                        }}
                      >
                        Customer Discount Code (CDP)
                      </div>
                      <div style={{ marginBottom: 15 }}>
                        <FormInput
                          noMarginBottom
                          lessPadding
                          greyBackground
                          labelText="Add code"
                          inputName="discountcode"
                          inputType="text"
                          defaultValue={searchDiscountcode}
                          onChange={e => setSearchDiscountcode(e.target.value)}
                          readOnly={promoCampaign !== ''}
                        />
                      </div>
                      <div
                        style={{
                          fontStyle: 'normal',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: 1.4,
                          marginBottom: 7,
                        }}
                      >
                        Promo code
                      </div>
                      <div>
                        <FormInput
                          lessPadding
                          greyBackground
                          labelText="Add code"
                          inputName="promocode"
                          inputType="text"
                          defaultValue={searchPromocode}
                          onChange={e => setSearchPromocode(e.target.value)}
                        />
                      </div>
                      <div
                        style={{
                          fontStyle: 'normal',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: 1.4,
                          marginBottom: 7,
                        }}
                      >
                        IT Code
                      </div>
                      <div>
                        <FormInput
                          lessPadding
                          greyBackground
                          labelText="Add code"
                          inputName="itcode"
                          inputType="text"
                          defaultValue={searchITCode}
                          onChange={e => setSearchITCode(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </Boxes>
            </div>
          </BookingColumn>
          <BookingColumn minWidth="160px" maxWidth="160px">
            {workerGetRates == 'ready' ? (
              <BookingSeachButton onClick={onSearch} disabled={false}>
                Search
              </BookingSeachButton>
            ) : (
              <BookingSeachButton onClick={void 0} disabled={true}>
                Loading
              </BookingSeachButton>
            )}
          </BookingColumn>
        </BookingWidget>
      </div>
    </>
  )
}

export default Itinerary
